import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: ${variables.sectionPadding};
    border-top: 1px solid #F1F1F1;
    border-bottom: 1px solid #F1F1F1;
    margin-top: 2em;

    .author-avatar {
        border-radius: 100%;
        margin-right: 2em;
        max-width: 8em;
    }

    .author-info {
        width: 100%;

        .author-name {
            color: #262626;
            font-size: 18px;
            font-weight: 700;
        }

        .author-specializtion {
            color: #9D9D9C;
            font-size: 12px;
            opacity: 0.9;

            .subtitle {
                font-weight: 700;
            }
        }

        .author-bio {
            color: #333333;
            font-size: 14px;
            margin-top: .5em;
            max-width: 600px;
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: ${variables.sectionPaddingMobile};
    }
`;
